export default __webpack_public_path__ + "static/media/IndiaSoft2025-Skyniche 3 1-19.4371d0a6.png";